



















































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';
import UiCepFormat from '@/components/UI/cep-format.vue';
import FadeTwin from '@/components/UI/fade-twin.vue';
import { decimalFormat } from '@/helpers/decimalFormat';
import { dateFormat } from '@/helpers/dateFormat';
import {
  ADMINISTRATION_WAYS_CENTRAL,
  ADMINISTRATION_WAYS_CENTRAL_LABEL,
  ADMINISTRATION_WAYS_PERIPHERAL,
  ADMINISTRATION_WAYS_PERIPHERAL_LABEL,
  INFUSION_TIME_OPTIONS,
} from '@/settings/consts/prescription-params';
import {
  PATIENT_TYPES,
  PATIENT_NEWBORN_TYPES,
  GENDERS,
} from '@/settings/consts/patient';
import IClientUnit from '@/interfaces/clientUnit';
import * as parameterService from '@/services/parameters';
import { toNumber } from '@/helpers/toNumber';

@Component({
  components: { UiCepFormat, FadeTwin },
})
export default class PrescriptionResumePacient extends BaseComponent {
  @Prop()
  public prescricao: any;

  @Prop()
  public imc: any;

  @Prop()
  public isTranscriptions: boolean;  

  public administrationWays: any = {};
  public patientTypes: any = {};
  public patientNewbornTypes: any = {};
  public genders: any = [];
  public infusionTimeOptions: any[] = [];

  get infusionTime(): string {
    const infusionTime = this.infusionTimeOptions.find(
      (x) => toNumber(x.value) === toNumber(this.prescricao.tempoInfusao),
    );

    if (!infusionTime) {
      return '-';
    }

    return infusionTime.text;
  }

  @Watch('prescricao.unidade')
  public onChangeClientUnit(val: IClientUnit): void {
    this.fetchInfusionTime();
  }

  @Watch('prescricao.medico')
  public onChangeDoctor(val): void {
    this.fetchInfusionTime();
  }

  public beforeMount(): void {
    this.getAdministrationWays();
    this.getPatientTypes();
    this.getGenders();
    this.onChangeClientUnit(this.prescricao.unidade);
  }

   public mounted(): void {
     if (this.isTranscriptions) {        
        this.compararTranscricoes();
     }
   }

   public updated(): void {
     if (this.isTranscriptions) {        
       this.compararTranscricoes();
     }
   }

  public calcQSPWater(desejado, digitado): string {
    var result  = this.formatValue(Math.max(desejado - digitado, 0));
    return result;
  }

  public formatValue(value: number): string {
    return decimalFormat(value);
  }

  public listaDatas(datas : any[]){
      var datasFormatadas = "";
      let idx = 0;
      datas.forEach(data => {
        if (idx++ > 0) {
          datasFormatadas += " - ";
        }
        datasFormatadas +=  dateFormat(data);
      });
      return datasFormatadas;
  }

  private formatDate = (value: string): string => dateFormat(value);

  private updateInfusionTime(value) {
    if (!value) {
      return '-';
    }
    return INFUSION_TIME_OPTIONS.find((x) => x.value === value).text;
  }

  private getAdministrationWays(): void {
    this.administrationWays = {
      [ADMINISTRATION_WAYS_CENTRAL]: ADMINISTRATION_WAYS_CENTRAL_LABEL,
      [ADMINISTRATION_WAYS_PERIPHERAL]: ADMINISTRATION_WAYS_PERIPHERAL_LABEL,
      [ADMINISTRATION_WAYS_CENTRAL]: ADMINISTRATION_WAYS_CENTRAL_LABEL,
      [ADMINISTRATION_WAYS_PERIPHERAL]: ADMINISTRATION_WAYS_PERIPHERAL_LABEL,
    };
  }

  private fetchInfusionTime() {
    const filter = {
      idMedico: !!this.prescricao.medico ? this.prescricao.medico.id : null,
      idUnidade: !!this.prescricao.unidade ? this.prescricao.unidade.id : null,
    };

    parameterService.getInfusionTime(filter).subscribe((data) => {
      this.infusionTimeOptions = data.valores
        .map((i) => ({
          text: `${i.valor} hora${i.valor != 1 ? 's' : ''}`,
          value: i.valor,
        }))
        .sort((a, b) => Number(a.value) - Number(b.value));
    });
  }

  private getPatientTypes(): void {
    this.patientTypes = PATIENT_TYPES;
    this.patientNewbornTypes = PATIENT_NEWBORN_TYPES;
  }

  private getGenders(): void {
    this.genders = GENDERS;
  }

  @Watch('infusionTime')
  public onChangeInfusionTime(val: any): void {
    // var value = document.querySelectorAll(`.data-item[data-label="tempo_de_infusão"]`)[0].querySelector('.value').textContent;
    // if(value == "-")
    //   return;
    // if(value != val)
    //   document.querySelectorAll(`.dim-twin[data-label="tempo_de_infusão"]`).forEach((i) => i.classList.add('colorDiff'));
    // else
    //   document.querySelectorAll(`.dim-twin[data-label="tempo_de_infusão"]`).forEach((i) => i.classList.remove('colorDiff'));

    //  this.itensSetColors(['volume_prescrito_de_produtos_ml_dia', 'volume_final_informado_ml_dia', 'água_q_s_p_ml_dia']) ;
  }

public itensSetColors(labels: string[]){
      var itensComparacao;
      for (const nome in labels) {
      itensComparacao = document.querySelectorAll(`.data-item[data-label="${labels[nome]}"]`)
      // info de paciente que tem nas duas transcrições.. (dos dois lados, compara as duas)      
      if(itensComparacao !== undefined && itensComparacao.length > 1){
        // info de paciente que estão dos dois lados e estão diferentes..        
        if(itensComparacao[0].querySelector('.value').textContent !=
            itensComparacao[1].querySelector('.value').textContent ){
              document
              .querySelectorAll(`.dim-twin[data-label="${labels[nome]}"]`)
              .forEach((i) => i.classList.add('colorDiff'));
        // info de paciente que estão dos dois lados e estão iguais em conteúdo..                   
        }else{
            document
              .querySelectorAll(`.dim-twin[data-label="${labels[nome]}"]`)
              .forEach((i) => i.classList.remove('colorDiff'));
        }
      }
      // info de paciente que so tem numa das transcrições.. (só tem 1 vez)
      else if (itensComparacao !== undefined && itensComparacao.length === 1){
          document
         .querySelectorAll(`.dim-twin[data-label="${labels[nome]}"]`)
         .forEach((i) => i.classList.add('colorDiff'));
      }      
  }
}

  public compararTranscricoes(){
    var elementosPatientResume =  document.querySelectorAll(`.dim-twin.data-item`);
    var labels = [];
    elementosPatientResume.forEach((i) =>
       labels.push(i.getAttribute("data-label"))
    );

    this.itensSetColors(labels);

    // var itensComparacao;
    //  for (const nome in labels) {
    //     itensComparacao = document.querySelectorAll(`.data-item[data-label="${labels[nome]}"]`)
    //      if(itensComparacao !== undefined && itensComparacao.length > 1){
    //        if(itensComparacao[0].querySelector('.value').textContent !=
    //           itensComparacao[1].querySelector('.value').textContent ){
    //              document
    //              .querySelectorAll(`.dim-twin[data-label="${labels[nome]}"]`)
    //              .forEach((i) => i.classList.add('colorDiff'));
    //        }else{
    //            document
    //              .querySelectorAll(`.dim-twin[data-label="${labels[nome]}"]`)
    //              .forEach((i) => i.classList.remove('colorDiff'));
    //        }
    //     }
    //  }
  }
}
